import { useLayoutEffect } from "react";
import { useParams } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import AgentChatContainerUI from "@/components/agent/AgentChatContainerUI";
import TitleBar from "@/components/ui/TitleBar";
import { routes } from "@/configs/router.config/routes";
import { useWorkspaceRedirect } from "@/hooks/useWorkspaceRedirect";
import { useAppStore } from "@/stores/ui/useAppStore";

const AgentPage: React.FC = () => {
  const { threadId } = useParams();
  const [_, setIsSideBarOpen] = useLocalStorage("isSideBarOpen", true);
  const setIsAgentMode = useAppStore(s => s.setIsAgentMode);

  useLayoutEffect(() => {
    setIsSideBarOpen(true);
    setIsAgentMode(true);
  }, [setIsSideBarOpen, setIsAgentMode]);

  useWorkspaceRedirect((workspaceId) => routes.agent(workspaceId));

  return (
    <div className="">
      <TitleBar title="エージェント" />

      <div className="flex flex-1">
        {/* メインチャットエリア */}
        <div className="flex-1 flex flex-col h-[calc(100vh-100px)] bg-white overflow-hidden">
          <div className="h-full flex flex-col overflow-hidden">
            {/* チャットコンテンツ */}
            <div className="flex-1 overflow-hidden">
              <AgentChatContainerUI key={threadId} className="h-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentPage;
